import { localize } from "@/i18n/translate";
import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { api, errorCode } from "@/lib/api";
import { usePortal } from "../i18n";
import { FilePicker } from "../Messages";
import { ErrorNote, FormField, PageTitle, btnPrimary, btnSecondary, inputCls } from "../ui";
const CATS = ["Leistungen", "Mitgliedschaft", "Kundenbereich", "Sonstiges"];
export default function NewTicket() {
  const {
    p,
    errText
  } = usePortal();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const initialCat = CATS.includes(params.get("thema")) ? params.get("thema") : "Leistungen";
  const [v, setV] = useState({
    subject: "",
    category: initialCat,
    message: ""
  });
  const [files, setFiles] = useState([]);
  const [errors, setErrors] = useState({});
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async e => {
    e.preventDefault();
    const r = {};
    if (v.subject.trim().length < 3) r.subject = p.newT.err.subject;
    if (v.message.trim().length < 10) r.message = p.newT.err.message;
    setErrors(r);
    if (Object.keys(r).length) return document.getElementById(`nt-${Object.keys(r)[0]}`)?.focus();
    setBusy(true);
    setErr(null);
    const fd = new FormData();
    fd.append("subject", v.subject.trim());
    fd.append("category", v.category);
    fd.append("message", v.message.trim());
    files.forEach(f => fd.append("files", f));
    try {
      const {
        data
      } = await api.post("/portal/tickets", fd);
      navigate(`/kundenbereich/anfragen/${data.id}`, {
        replace: true
      });
    } catch (ex) {
      setErr(errText(errorCode(ex)));
      setBusy(false);
    }
  };
  const aria = k => ({
    "aria-invalid": errors[k] ? true : undefined,
    "aria-describedby": errors[k] ? `nt-${k}-error` : undefined
  });
  return <div data-testid="new-ticket-page">
      <Link to="/kundenbereich" className="mb-8 inline-flex items-center gap-2 text-sm font-medium hover:text-signal"><ArrowLeft className="h-4 w-4" aria-hidden="true" /> {localize(p.thread.back)}</Link>
      <PageTitle eyebrow={p.area} title={localize(p.newT.title)} />
      <p className="mt-6 max-w-xl text-mute">{localize(p.newT.intro)}</p>
      <form onSubmit={submit} noValidate className="mt-10 max-w-2xl space-y-6" data-testid="new-ticket-form">
        <ErrorNote testId="new-ticket-error">{localize(err)}</ErrorNote>
        <FormField id="nt-subject" label={p.newT.subject} error={errors.subject}>
          <input id="nt-subject" value={v.subject} maxLength={160} onChange={e => setV({
          ...v,
          subject: e.target.value
        })} className={inputCls(errors.subject)} data-testid="new-ticket-subject" {...aria("subject")} />
        </FormField>
        <FormField id="nt-category" label={p.newT.category}>
          <select id="nt-category" value={v.category} onChange={e => setV({
          ...v,
          category: e.target.value
        })} className={inputCls(false)} data-testid="new-ticket-category">
            {localize(CATS.map(c => <option key={c} value={c}>{localize(p.categories[c])}</option>))}
          </select>
        </FormField>
        <FormField id="nt-message" label={p.newT.message} error={errors.message}>
          <textarea id="nt-message" rows={7} value={v.message} maxLength={5000} placeholder={localize(p.newT.placeholder)} onChange={e => setV({
          ...v,
          message: e.target.value
        })} className={`${inputCls(errors.message)} resize-y`} data-testid="new-ticket-message" {...aria("message")} />
        </FormField>
        <FilePicker files={files} setFiles={setFiles} onError={c => setErr(c ? errText(c) : null)} idPrefix="new-ticket" />
        <div className="flex flex-col gap-3 border-t border-ink/15 pt-6 sm:flex-row">
          <button type="submit" disabled={busy} className={btnPrimary} data-testid="new-ticket-submit">
            {localize(busy && <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />)} {localize(p.newT.submit)}
          </button>
          <Link to="/kundenbereich" className={btnSecondary}>{localize(p.newT.cancel)}</Link>
        </div>
      </form>
    </div>;
}
